import { render, staticRenderFns } from "./editRes.vue?vue&type=template&id=27eb4234&scoped=true&"
import script from "./editRes.vue?vue&type=script&lang=js&"
export * from "./editRes.vue?vue&type=script&lang=js&"
import style0 from "./editRes.vue?vue&type=style&index=0&id=27eb4234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eb4234",
  null
  
)

export default component.exports